import LandingLayout from 'components/templates/LandingLayout';
import PolicyDetail from 'components/UI/organisms/landing/policydetail/PolicyDetail';

const PolicyDetailPage = () => {
  return <LandingLayout content={<PolicyDetail />} />;
};

export default PolicyDetailPage;
